"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceManagementType = void 0;
var DataSourceManagementType;
(function (DataSourceManagementType) {
    DataSourceManagementType["API"] = "API";
    DataSourceManagementType["MANUAL"] = "MANUAL";
})(DataSourceManagementType = exports.DataSourceManagementType || (exports.DataSourceManagementType = {}));
//# sourceMappingURL=dataSourceManagementType.js.map